const customergroups = {
	title: "Customer groups",
	new_customergroup: "New customer group",
	edit_customergroup: "Edit group: {name}",
	view_customergroup: "Show group: {name}",
	list_title: "Customer groups",
	list_subtitle: "Handle groups",
	create_title: "Create group",
	update_title: "Update group",
	id: "ID",
	name: "Name",
	status: "Status",
	created_by: "Created",
};
export default customergroups;